import { Menu } from '@lmc/ui-kit'
import { ConfigProvider } from 'antd'
import type React from 'react'
import styled from 'styled-components'
import {
  type CustomMenuItemType,
  getNavigationMenuItems,
  navigationTheme
} from 'utils'

type ReportSidebarNavigationProps = {
  menuItems?: CustomMenuItemType[]
  navigate: (key: string) => void
  defaultSelectedKey: string
  defaultOpenKey: string
}

const StyledContainer = styled.div`
  margin-bottom: 0px;
  background-color: ${(props) => props.theme.color.neutral.color11} !important;
  max-width: 290px;
  width: 100%;
  height: 100%;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-right: 24px;
    margin-left: 24px;
    max-width: unset;
    width: 100%;
  }

  @media print {
    display: none;
  }
`

const StyledMenuContainer = styled.div`
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    max-height: unset;
  }
`

const ReportSidebarNavigation: React.FC<ReportSidebarNavigationProps> = ({
  menuItems,
  navigate,
  defaultSelectedKey,
  defaultOpenKey
}) => {
  const items = getNavigationMenuItems(menuItems)

  return (
    <StyledContainer>
      <StyledMenuContainer>
        <ConfigProvider theme={navigationTheme}>
          <Menu
            onClick={({ key }) => navigate(`${key}`)}
            style={{ border: 'none' }}
            defaultSelectedKeys={[defaultSelectedKey]}
            defaultOpenKeys={[defaultOpenKey]}
            mode="inline"
            theme="light"
            inlineCollapsed={false}
            items={items}
          />
        </ConfigProvider>
      </StyledMenuContainer>
    </StyledContainer>
  )
}

export default ReportSidebarNavigation
